/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetChatSummariesResponseData,
  GetChatSummariesResponseDataFromJSON,
  GetChatSummariesResponseDataFromJSONTyped,
  GetChatSummariesResponseDataToJSON
} from './GetChatSummariesResponseData'

/**
 *
 * @export
 * @interface GetChatSummariesSendedByUserResponse
 */
export interface GetChatSummariesSendedByUserResponse {
  /**
   *
   * @type {number}
   * @memberof GetChatSummariesSendedByUserResponse
   */
  status?: number
  /**
   *
   * @type {GetChatSummariesResponseData}
   * @memberof GetChatSummariesSendedByUserResponse
   */
  data?: GetChatSummariesResponseData
}

export function GetChatSummariesSendedByUserResponseFromJSON(json: any): GetChatSummariesSendedByUserResponse {
  return GetChatSummariesSendedByUserResponseFromJSONTyped(json, false)
}

export function GetChatSummariesSendedByUserResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetChatSummariesSendedByUserResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetChatSummariesResponseDataFromJSON(json['data'])
  }
}

export function GetChatSummariesSendedByUserResponseToJSON(value?: GetChatSummariesSendedByUserResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetChatSummariesResponseDataToJSON(value.data)
  }
}
